import { PurchaseEvent } from '@/usecases/event-bus-for-third-party/event'
import { DataLayerService } from '@/vendor/gtm/data-layer'
import { GpEcommerceEvent, gpEcommerceEventFactory } from '@/vendor/gtm/events/gp/ecommerce'

export function sendEcommerceEventToGtm(event: PurchaseEvent): void {
  const dataLayerService = new DataLayerService()

  gpEcommerceEventFactory.createFromEventBusPurchaseEvent(event).forEach((e: GpEcommerceEvent) => {
    dataLayerService.push(e)
  })
}
